export function isDateValid(date) {
    if (!date) return false;
    const newDate = new Date(date);
    if (isFinite(newDate.getTime())) {
        return true;
    }
    return false;
}